import { render } from "./genericIdentity.vue?vue&type=template&id=9b3a6820&scoped=true"
import script from "./genericIdentity.vue?vue&type=script&lang=js"
export * from "./genericIdentity.vue?vue&type=script&lang=js"

import "./genericIdentity.vue?vue&type=style&index=0&id=9b3a6820&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3a6820"]])

export default __exports__